import { t } from '@hefe/i18n';
import { KnowledgeBaseArticle } from '@hefe/models';
import { Button, Skeleton, Spin, Typography } from 'antd';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

interface HighlightArticlesListComponentProps {
  title: string;
  articles: KnowledgeBaseArticle[];
  fetching: boolean;
}

export default function HighlightArticlesListComponent(
  props: HighlightArticlesListComponentProps
) {
  const { title, articles, fetching } = props;

  const navigate = useNavigate();

  const list = useMemo(() => {
    if (!articles || articles.length === 0) {
      return (
        <Typography.Text>{t('knowledge_base.articles.empty')}</Typography.Text>
      );
    }

    return articles.map((article) => (
      <li>
        <Button
          key={article.id}
          onClick={() => navigate('/knowledge-base/articles/' + article.id)}
          type="link"
        >
          {article.title}
        </Button>
      </li>
    ));
  }, [articles, navigate]);

  return (
    <Skeleton
      loading={fetching}
      active
      paragraph={{ rows: 4, width: '90%' }}
      title
      style={{ width: '90%' }}
    >
      <Typography.Title level={4}>{title}</Typography.Title>
      <ul>{list}</ul>
    </Skeleton>
  );
}
